import type { FeedbackChannels, MessageType } from './draft-feedback.service.types';

export type ResponseMessage = { text: string; type: MessageType; context: string };

export type CallbackFunction = (
  messages: ResponseMessage[],
  channel: FeedbackChannels,
  methodIdentifier: string,
) => ResponseMessage[];

export class MessageDraftServerService {
  private static messagesFilterCallbacks = new Map<string, CallbackFunction>();

  static addCallback(draftId: string, callbackFunction: CallbackFunction): void {
    MessageDraftServerService.messagesFilterCallbacks.set(draftId, callbackFunction);
  }

  static removeCallback(draftId: string): void {
    MessageDraftServerService.messagesFilterCallbacks.delete(draftId);
  }

  static filterMessageByDraftId(
    messages: ResponseMessage[],
    draftId: string,
    draftChannel: FeedbackChannels,
    methodIdentifier: string,
  ): ResponseMessage[] {
    if (MessageDraftServerService.messagesFilterCallbacks.has(draftId)) {
      messages =
        MessageDraftServerService.messagesFilterCallbacks.get(draftId)?.(messages, draftChannel, methodIdentifier) ||
        messages;
    }
    return messages;
  }
}
